<template>
  <Pill color="info" variant="muted" class="inline-flex items-center gap-1 shrink-0">
    <SprintIcon class="size-4" aria-hidden="true" />
    <span>{{ $t("Sprint") }}</span>
  </Pill>
</template>

<script setup lang="ts">
import { Pill } from "@xs2event/js-lib/components";
import SprintIcon from "~icons/material-symbols/electric-bolt";
</script>
